import DocumentsList from '../../slices/user_guide/documents/DocumentsList'
import DocumentsDetails from '../../slices/user_guide/documents/DocumentsDetails'

const userGuideReducer = {
    documentsList: DocumentsList,
    documentsDetails: DocumentsDetails,
};

export default userGuideReducer;
